export default __webpack_public_path__ + "static/media/caroussel-5.b05a44dc.png";